import { formatEther, parseEther } from '@ethersproject/units';
import { useWeb3React } from '@web3-react/core';
import { useEffect, useState } from 'react';
import Detail from '../../../../../components/Detail';
import { formatUSD } from '../../../../../helpers/formats';
import useIsMounted from '../../../../../hooks/useIsMounted';
import useTotalAccumulatedVoSpool from '../../../../../hooks/web3/vault/useTotalAccumulatedVoSpool';
import useTotalStakedSpool from '../../../../../hooks/web3/vault/useTotalStakedSpool';
import useUserAccumulatedVoSpool from '../../../../../hooks/web3/vault/useUserAccumulatedVoSpool';
import useUserStakedSpool from '../../../../../hooks/web3/vault/useUserStakedSpool';

const NextVoSpoolRewards = () => {
    const { library, account } = useWeb3React();

    const { userStakedSpool } = useUserStakedSpool();

    const { totalStakedSpool } = useTotalStakedSpool();

    const { userAccumulatedVoSpool } = useUserAccumulatedVoSpool();

    const { totalAccumulatedVoSpool } = useTotalAccumulatedVoSpool();

    const isMounted = useIsMounted();

    const [absoluteAmount, setAbsoluteAmount] = useState('0');

    useEffect(() => {
        if (
            !library ||
            !account ||
            !userStakedSpool ||
            !totalStakedSpool ||
            !userAccumulatedVoSpool ||
            !totalAccumulatedVoSpool
        )
            return;

        (async () => {
            try {
                // 2.4mil SPOOL divided by 13 weeks
                const rewardPerTranche = parseEther('57000');

                //  calculate additional voSPOOL increase for next tranche
                const nextTrancheVoSpoolIncrease = parseEther(
                    totalStakedSpool.toString()
                ).div(156);

                // next tranche total voSPOOL
                const nextTrancheTotalVoSpoolAmount = nextTrancheVoSpoolIncrease.add(
                    parseEther(totalAccumulatedVoSpool)
                );

                // use user's staked SPOOL if he has staked, else use 1 SPOOL to simulate APY
                // if he staked now
                const userStakedSpoolAmount = parseEther(userStakedSpool).isZero()
                    ? parseEther('1')
                    : parseEther(userStakedSpool);

                // calculate additional user voSPOOL increase for next tranche
                const nextTrancheUserVoSpoolIncrease = userStakedSpoolAmount.div(156);

                // next tranche user total voSPOOL ( userAccumulatedVoSpool = userVoSPOOL)
                const nextTrancheUserVoSpoolAmount = nextTrancheUserVoSpoolIncrease.add(
                    parseEther(userAccumulatedVoSpool)
                );

                // absolute amount ( check if Staked Spool)
                const nextTrancheUserReward = rewardPerTranche
                    .mul(nextTrancheUserVoSpoolAmount)
                    .div(nextTrancheTotalVoSpoolAmount);

                const nextTrancheAbsoluteAmount = !parseEther(userStakedSpool).isZero()
                    ? formatEther(nextTrancheUserReward)
                    : '0';

                // calculate user APY based on next tranche
                // const nextTrancheUserApy = nextTrancheUserReward
                //     .mul(365)
                //     .mul(100000) // for 3 decimal precision
                //     .div(7)
                //     .div(userStakedSpoolAmount);

                if (isMounted()) {
                    setAbsoluteAmount(nextTrancheAbsoluteAmount);
                    // setApy(formatUnits(nextTrancheUserApy, 3)); // set to 3 decimals
                }
            } catch (error) {
                console.log(error);
            }
        })();
    }, [
        library,
        account,
        userStakedSpool,
        totalStakedSpool,
        userAccumulatedVoSpool,
        totalAccumulatedVoSpool,
        isMounted,
    ]);

    return (
        <Detail
            title={`Your Next voSPOOL Epoch Rewards`}
            value={`${formatUSD(absoluteAmount || 0)} $SPOOL`}
        />
    );
};

export default NextVoSpoolRewards;
